<section class="blue-bg iq-analytics-clients">
    <div class="container">
        <div class="row">
            <div class="col-lg-5 col-sm-12 align-self-center mb-4 mb-lg-0">
                <app-title-section [titleSectionProp]="titleSectionProp"></app-title-section>
                <div class="iq-btn-container">
                    <a class="iq-button d-inline" [href]="pricingLink">{{'PRICE_LIST' | translate}}</a>
                </div>
            </div>
            <div class="col-lg-7 col-sm-12">
                <app-our-clients-icons></app-our-clients-icons>
            </div>
        </div>
    </div>
</section>
